export default function storeQueryInSession(name, value, queryType) {
  const storedQueries = window.sessionStorage.getItem(queryType);
  const splitQueries = storedQueries ? storedQueries.substr(1).split('&') : [];

  const foundQueryIndex = splitQueries.findIndex(query => query.includes(name));
  const newQuery = `${name}=${value}`;

  if (foundQueryIndex > -1) {
    splitQueries.splice(foundQueryIndex, 1, newQuery);
  } else {
    splitQueries.push(newQuery);
  }

  window.sessionStorage.setItem(queryType, `?${splitQueries.join('&')}`);
}
